export const SDOHRiskLookup = {
  high: {
    text: "High Risk",
    color: "#F04438",
    text_color: "#F04438",
    bgcolor: "#ffeceb",
    pill_type: "urgent",
    dot_color: "#F04438",
  },
  "high risk": {
    text: "High Risk",
    color: "#F04438",
    text_color: "#F04438",
    bgcolor: "#ffeceb",
    pill_type: "urgent",
    dot_color: "#F04438",
  },
  medium: {
    text: "Medium Risk",
    color: "#915200",
    text_color: "#915200",
    bgcolor: "#fff4e6",
    pill_type: "medium",
    dot_color: "#F04438",
  },
  low: {
    text: "Not at Risk",
    color: "#12B76A",
    text_color: "#343A40",
    bgcolor: "#eafff5",
    pill_type: "low",
    dot_color: "#FFF",
  },
  "not at risk": {
    text: "Not at Risk",
    color: "#12B76A",
    text_color: "#343A40",
    bgcolor: "#eafff5",
    pill_type: "low",
    dot_color: "#FFF",
  },
  na: {
    text: "Not on File",
    color: "#395e9d",
    text_color: "#343A40",
    bgcolor: "#f1f1f5",
    pill_type: "na",
    dot_color: "#FFF",
  },
};

export const assessmentNameLookup = {
  sdoh: "Social Determinants of Health",
  "daily-dbt": "Daily DBT",
};

export const flagLabels = {
  "severe depression": { backgroundColor: "#f9e3df", color: "#C72D22" },
  "highly likely": { backgroundColor: "#f9e3df", color: "#C72D22" },
  "severe pain": { backgroundColor: "#f9e3df", color: "#C72D22" },
  "high risk": { backgroundColor: "#f9e3df", color: "#C72D22" },
  "severe anxiety": { backgroundColor: "#f9e3df", color: "#C72D22" },
  "moderate to severe depression": {
    backgroundColor: "#f9e3df",
    color: "#C72D22",
  },
  "moderate depression": {
    backgroundColor: "#f9e3df",
    color: "#C72D22",
  },
  depression: { backgroundColor: "#e1e8ff", color: "#395e9d" },
  "no tag group": { backgroundColor: "#f1f1f5", color: "#395e9d" },
  "minimal depression": { backgroundColor: "#e1e8ff", color: "#395e9d" },
  "mild depression": { backgroundColor: "#e1e8ff", color: "#395e9d" },
  "mild or moderate pain": { backgroundColor: "#e1e8ff", color: "#395e9d" },
  likely: { backgroundColor: "#e1e8ff", color: "#395e9d" },
  "mild anxiety": { backgroundColor: "#e1e8ff", color: "#395e9d" },
  moderate: { backgroundColor: "#e1e8ff", color: "#395e9d" },
  "minimal anxiety": { backgroundColor: "#e1e8ff", color: "#395e9d" },
  "moderately likely": { backgroundColor: "#e1e8ff", color: "#395e9d" },
  "moderate anxiety": { backgroundColor: "#e1e8ff", color: "#395e9d" },
  "moderate risk": { backgroundColor: "#e1e8ff", color: "#395e9d" },
  suicidal: { backgroundColor: "#f9e3df", color: "#C72D22" },
  negative_mood: { backgroundColor: "#f9e3df", color: "#C72D22" },
  no: { backgroundColor: "#f9e3df", color: "#C72D22" },
  anxiety: { backgroundColor: "#f9e3df", color: "#C72D22" },
  positive_mood: { backgroundColor: "#d4fce9", color: "#008446" },
  yes: { backgroundColor: "#d4fce9", color: "#008446" },
  "not at risk": { backgroundColor: "#d4fce9", color: "#008446" },
  "no pain": { backgroundColor: "#d4fce9", color: "#008446" },
  "very unlikely": { backgroundColor: "#d4fce9", color: "#008446" },
  "no anxiety": { backgroundColor: "#d4fce9", color: "#008446" },
};
export const dateOptions = [
  {
    label: "Past 3 Months",
    value: 3,
  },
  {
    label: "Past 6 Months",
    value: 6,
  },
  {
    label: "Past Year",
    value: 12,
  },
];

export const dateFilters = [
  // { label: "All", value: "all" },
  { label: "This Week", value: "week" },
  { label: "Past Week", value: "pastweek" },
  { label: "2 Weeks", value: "2week" },
  { label: "This Month", value: "month" },
  { label: "3 Months", value: "3months" },
  { label: "6 Months", value: "6months" },
];

export const dateFiltersWithAll = [
  { label: "All", value: "all" },
  { label: "This Week", value: "week" },
  { label: "Past Week", value: "pastweek" },
  { label: "2 Weeks", value: "2week" },
  { label: "This Month", value: "month" },
  { label: "3 Months", value: "3months" },
  { label: "6 Months", value: "6months" },
];

export const reportStatusFilters = [
  { label: "All Reports", value: "all" },
  { label: "Ready", value: "ready" },
  { label: "Not Ready", value: "not ready" },
];

export const notesFilter = [
  {
    value: "All notes",
    label: "All Notes",
  },
  {
    value: "My Personal Notes",
    label: "My Personal Notes",
  },
  {
    value: "Patient BHI Notes",
    label: "Patient BHI Notes",
  },
];
export const gapDays = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "14", value: "14" },
  { label: "30", value: "30" },
  { label: "60", value: "60" },
  { label: "90", value: "90" },
];

export const gapDaysText = {
  1: "Every day",
  7: "Every week",
  14: "Every 2 weeks",
  30: "Every month",
  60: "Every 2 months",
  90: "Every 3 months",
};

export const pinnedContentLabels = {
  sleep: { bgColor: "#E6F0FC", color: "#333" },
  "substance abuse": { bgColor: "#D4FCE9", color: "#333" },
  relaxation: { bgColor: "#FBE6FC", color: "#333" },
  pain: { bgColor: "#FCF6E6", color: "#333" },
  blogs: { bgColor: "#FCE7E6", color: "#333" },
  CBT: { bgColor: "#E6FCFC", color: "#333" },
  caregivers: { bgColor: "#FBEDC9", color: "#333" },
  anxiety: { bgColor: "#E6F0FC", color: "#333" },
  adhd: { bgColor: "#D4FCE9", color: "#333" },
  burnout: { bgColor: "#FBEDC9", color: "#333" },
  depression: { bgColor: "#E6FCFC", color: "#333" },
  wellbeing: { bgColor: "#FCE7E6", color: "#333" },
  trauma: { bgColor: "#FCF6E6", color: "#333" },
};

export const pinnedContentLabelsColors = {
  sleep: "#73A1D8",
  "substance abuse": "#A2DCC0",
  relaxation: "#E5A1E7",
  pain: "#EBCE83",
  blogs: "#FFB7B2",
  CBT: "#7CE1E1",
  caregivers: "#E0A100",
  anxiety: "#8A95A3",
  adhd: "#0DBF6A",
  burnout: "#FF82D4",
  depression: "#F67474",
  wellbeing: "#A298E0",
  trauma: "#9FE27F",
};

export const typeOptions = [
  { label: "ACO", value: "ACO_EXECUTIVE" },
  { label: "Provider", value: "PROVIDER" },
  { label: "Other", value: "Other" },
];

export const paymentTypeOptions = [
  { label: "Card", value: "card" },
  { label: "Cheque", value: "cheque" },
  { label: "Cash", value: "cash" },
];

export const bulkPatientCSVLink =
  "https://genericrosebucket.s3.amazonaws.com/ReportTemplate.csv";

export const assesmentsToSelectAdult = [
  {
    label: "SDoH",
    value: "SDoH",
  },
  {
    label: "PHQ-9",
    value: "PHQ9",
  },
  {
    label: "PROMIS",
    value: "PROMIS",
  },
  {
    label: "GAD-7",
    value: "GAD7",
  },
  {
    label: "PHQ-8",
    value: "PHQ8",
  },
  {
    label: "Pain",
    value: "Pain",
  },
];

export const assesmentsToSelectYouth = [
  {
    label: "YOQ",
    value: "YOQ",
  },
  {
    label: "YOQ-1",
    value: "YOQ1",
  },
  {
    label: "PHQ-A",
    value: "PHQA",
  },
  {
    label: "PHQ-8",
    value: "PHQ8",
  },
  {
    label: "PHQ-9",
    value: "PHQ9",
  },
  {
    label: "GAD-7",
    value: "GAD7",
  },
  {
    label: "Sleep",
    value: "Sleep",
  },
  {
    label: "Columbia",
    value: "Columbia",
  },
  {
    label: "SCARED",
    value: "SCARED",
  },
  {
    label: "FIBSER",
    value: "FIBSER",
  },
  {
    label: "PROMIS",
    value: "PROMIS",
  },
  {
    label: "Daily-Med",
    value: "DailyMed",
  },
  {
    label: "Daily-DBT",
    value: "DailyDBT",
  },
];

export const ROLES_LIST = [
  "CLINIC_ADMIN",
  "CLINICAL_STAFF",
  "CAREGIVER",
  "ACO_EXECUTIVE",
  "INVOICING_ADMIN",
  "SALES_MANAGER",
];

export const graphEmojiScale = [
  "",
  "😄 Great",
  "😁 Good",
  "🙂 Okay",
  "😢 Bad",
  "😭 Awful",
];

export const ContentTileColors = {
  Audio: "#3DD5E2",
  Videos: "#BB6BD9",
  Article: "#044CB9",
};
